var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 56,
    viewBox: "0 0 57 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.578125,
    width: 56,
    height: 56,
    rx: 28,
    fill: "#FF5B51",
    fillOpacity: 0.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5781 15C17.8167 15 15.5781 17.2386 15.5781 20C15.5781 22.7614 17.8167 25 20.5781 25C23.3395 25 25.5781 22.7614 25.5781 20C25.5781 17.2386 23.3395 15 20.5781 15ZM17.5781 20C17.5781 18.3431 18.9213 17 20.5781 17C22.235 17 23.5781 18.3431 23.5781 20C23.5781 21.6569 22.235 23 20.5781 23C18.9213 23 17.5781 21.6569 17.5781 20ZM20.5781 31C17.8167 31 15.5781 33.2386 15.5781 36C15.5781 38.7614 17.8167 41 20.5781 41C23.3395 41 25.5781 38.7614 25.5781 36C25.5781 33.2386 23.3395 31 20.5781 31ZM17.5781 36C17.5781 34.3431 18.9213 33 20.5781 33C22.235 33 23.5781 34.3431 23.5781 36C23.5781 37.6569 22.235 39 20.5781 39C18.9213 39 17.5781 37.6569 17.5781 36ZM31.5781 20C31.5781 17.2386 33.8167 15 36.5781 15C39.3396 15 41.5781 17.2386 41.5781 20C41.5781 22.7614 39.3396 25 36.5781 25C33.8167 25 31.5781 22.7614 31.5781 20ZM36.5781 17C34.9213 17 33.5781 18.3431 33.5781 20C33.5781 21.6569 34.9213 23 36.5781 23C38.235 23 39.5781 21.6569 39.5781 20C39.5781 18.3431 38.235 17 36.5781 17ZM36.5781 31C33.8167 31 31.5781 33.2386 31.5781 36C31.5781 38.7614 33.8167 41 36.5781 41C39.3396 41 41.5781 38.7614 41.5781 36C41.5781 33.2386 39.3396 31 36.5781 31ZM33.5781 36C33.5781 34.3431 34.9213 33 36.5781 33C38.235 33 39.5781 34.3431 39.5781 36C39.5781 37.6569 38.235 39 36.5781 39C34.9213 39 33.5781 37.6569 33.5781 36Z",
    fill: "#FF5B51"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDapp);
export default __webpack_public_path__ + "static/media/dapp.f03c0b4f638224368e80c6d363ce4cb7.svg";
export { ForwardRef as ReactComponent };